module.exports = __webpack_public_path__ + "static/img/hzhb.49910b9e.png";